import { Component, Inject, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-marca',
  templateUrl: './create-marca.component.html',
  styleUrls: ['./create-marca.component.css'],
})
export class CreateMarcaComponent implements OnInit, AfterViewInit {
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;
  
  form: UntypedFormGroup;
  type = 'Nuevo';

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CreateMarcaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    
    this.form = this.fb.group({
      code: ['', Validators.required],
      name: ['', Validators.required]
    });
    if (data) {
      this.type = data.type;
      this.form.patchValue({
        code: data.code,
        name: data.name
      });
    }
  }

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Nueva Marca';
    }
    
    // Generar código automático solo para nuevas marcas (no para edición)
    if (this.type === 'Nuevo' || this.type === 'Nueva') {
      this.generateDefaultCode();
      
      // Escuchar cambios en el nombre para actualizar el código automáticamente
      this.form.get('name')?.valueChanges.subscribe(nombre => {
        if (nombre && (this.type === 'Nuevo' || this.type === 'Nueva')) {
          const codigoGenerado = this.generateCodeFromName(nombre);
          this.form.get('code')?.setValue(codigoGenerado, { emitEvent: false });
        }
      });
    }
  }

  ngAfterViewInit(): void {
    // Hacer focus en el campo nombre después de que la vista se haya inicializado
    // Usar un timeout más largo para asegurar que Angular Material haya terminado su inicialización
    setTimeout(() => {
      if (this.nameInput && this.nameInput.nativeElement) {
        this.nameInput.nativeElement.focus();
        this.nameInput.nativeElement.select(); // También seleccionar el texto si existe
      }
    }, 300);
  }

  // Generar código numérico basado en total de registros + 1
  generateDefaultCode(): void {
    // Si tenemos datos inyectados con las marcas existentes, usar total + 1
    if (this.data && this.data.existingBrands) {
      const totalRegistros = this.data.existingBrands.length;
      const nextNumber = totalRegistros + 1;
      const defaultCode = nextNumber.toString();
      this.form.get('code')?.setValue(defaultCode);
    } else {
      // Fallback: usar timestamp si no tenemos acceso a las marcas existentes
      const timestamp = Date.now().toString().slice(-6);
      const defaultCode = `MAR${timestamp}`;
      this.form.get('code')?.setValue(defaultCode);
    }
  }



  // Generar código basado en el total de registros + 1
  generateCodeFromName(nombre: string): string {
    if (!nombre || nombre.trim().length === 0) {
      return this.form.get('code')?.value || this.generateDefaultCodeOnly();
    }
    
    // Usar total de registros + 1 para cualquier nombre
    if (this.data && this.data.existingBrands) {
      const totalRegistros = this.data.existingBrands.length;
      const nextNumber = totalRegistros + 1;
      return nextNumber.toString();
    }
    
    // Fallback si no hay datos de marcas existentes
    return this.generateDefaultCodeOnly();
  }

  // Método auxiliar para generar código por defecto
  private generateDefaultCodeOnly(): string {
    if (this.data && this.data.existingBrands) {
      const totalRegistros = this.data.existingBrands.length;
      const nextNumber = totalRegistros + 1;
      return nextNumber.toString();
    }
    
    // Fallback: usar timestamp si no hay datos
    const timestamp = Date.now().toString().slice(-6);
    return `MAR${timestamp}`;
  }

  // Método para regenerar código manualmente
  regenerateCode(): void {
    const nombre = this.form.get('name')?.value;
    if (nombre && nombre.trim().length > 0) {
      const codigoGenerado = this.generateCodeFromName(nombre);
      this.form.get('code')?.setValue(codigoGenerado);
    } else {
      this.generateDefaultCode();
    }
  }

  guardar() {
    this.dialogRef.close(this.form.getRawValue());
  }

  cancelar() {
    this.dialogRef.close();
  }
}
